module.exports = __webpack_public_path__ + "public/static/img/mosaico_quem_somos.d332047.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/img/mosaico_quem_somos.png
// module id = MS8Z
// module chunks = 1